import {ReceivingInstructionDetailRequest} from './interface/receiving-instruction-detail-request';
import {CodeConverterOptions} from './../../../../core/models/options/code-converter-options';
import {LaasOption} from './../../../../core/models/laas-option';
import {Table} from 'primeng/table';
import {FacilityOptions} from './../../../../core/models/options/facility-options';
import {ReceivingInstructionResponse} from './interface/receiving-instruction-response';
import {ReceivingInstructionService} from './../../services/receiving-instruction.service';
import {ReceivingInstructionRequest} from './interface/receiving-instruction-request';
import {CommonDataService} from './../../../../core/services/common-data.service';
import {FacilityService} from 'src/app/core/services/facility.service';
import {DropdownOptionsService} from 'src/app/core/services/dropdown-options.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SessionBaseComponent} from 'src/app/shared/components/session.base.component';
import {Component, computed, Injector, OnInit, signal, Signal, ViewChild} from '@angular/core';
import {
  concatHeaderAndDetailTaskArray,
  deepCopy,
  getDataScopeByPermission,
  isNullOrEmpty,
  laaSFormatString,
  mapToObject,
  addDays,
} from 'src/app/core/utils/common-functions';
import {PageInfo} from 'src/app/core/models/page-info';
import {copyFormControl} from 'src/app/core/utils/validation-functions';
import {DateTableColumn} from 'src/app/core/models/date-table-column';
import {ReceivingInstructionDetailResponse} from './interface/receiving-instruction-detail-response';
import {ReceivingInstructionDetailReturnRequest} from './interface/receiving-instruction-detail-return-request';
import {TaskListOptions} from 'src/app/core/models/options/task-list-options';
import {UpdateAdvisingDetailTaskRequest} from './interface/receiving-instruction-detail-updaterequest';
import {ConfirmEventType} from 'primeng/api';
import {UpdateAdvisingHeaderTaskRequest} from './interface/receiving-instruction-header-updaterequest';
import {endOfDay, startOfDay} from 'date-fns';
import {PermissionConstants} from 'src/app/core/constants/permission-constants.constant';
import {EmployeeListOptions} from 'src/app/core/models/options/employee-list-options';
import {UserPreferenceConstants} from '../../../../core/constants/user-preference-constants.constant';
import {AdvisingServiceService} from '../../services/advising-service.service';
import {FileUploadDialogComponent} from 'src/app/shared/components/file-upload-dialog/file-upload-dialog.component';
import {ReceivingInstructionFilesRequest} from './interface/receiving-instruction-file-request';
import {ReceivingInstructionFileItem} from './interface/receiving-instruction-file-item';
import {ReceivingInstructionFileUpdateRequest} from './interface/receiving-instruction-file-update-request';
import {ActivatedRoute, Params} from '@angular/router';
import {CalendarComponent} from 'src/app/shared/components/calendar/calendar.component';
import {LaasOptionAdvance} from '../../../../core/models/laas-option-advance';
import {TaskLogicServiceService} from '../../services/task-logic-service.service';
import {AdvanceTaskMaintenanceComponent} from '../../../component/advance-task-maintenance/advance-task-maintenance.component';
import {ReceivingInstructionDetailGroupBySku} from './interface/receiving-instruction-detail-groupbysku';
import {ReceivingInstructionBatchUpdateComponent} from '../receiving-instruction-batch-update/receiving-instruction-batch-update.component';
import {AddressMaintainanceService} from '../../../setting/service/address-maintainance.service';
import {put} from 'request';
import {UpdateReceivingTaskRequest} from './interface/update-receiving-task-request';
import {tr} from 'date-fns/locale';
import { OrderQueryScopeEnum } from 'src/app/core/enums/order-query-scope.enum';

@Component({
  selector: 'laas-receiving-instruction',
  templateUrl: './receiving-instruction.component.html',
  styleUrls: ['./receiving-instruction.component.scss']
})
export class ReceivingInstructionComponent extends SessionBaseComponent implements OnInit {

  currentLang: string = this.laasSetting.language;
  isSearchFormOpen: boolean;
  isHeaderTableOpen: boolean;
  isDetailTableOpen: boolean;
  isHeaderLoading: boolean;
  isDetailLoading: boolean;
  headerChecked: boolean;
  detailChecked: boolean;
  firstSearch: boolean;
  canEditTable: boolean;
  editMode: boolean;
  editStatus: string;
  canEditHeaderTaskRemark: boolean;
  canEditDetailTaskRemark: boolean;
  isShowBatchUpdate: boolean;
  visibleTaskAdvance: boolean;

  detailSelectedDisplayMode: string;
  displayDetailModeByLine: boolean = true;
  displayDetailModeBySku: boolean;

  searchForm: FormGroup;
  defaultCreateDt: Date[];
  pageInfo: PageInfo;
  sortInfo?: [{ property: string; direction: number }];
  detailPageInfo: PageInfo;
  detailSortInfo?: [{ property: string; direction: number }];
  first: number;

  facilityOptions = signal<LaasOption[]>([]);
  vendorNumberOptions: LaasOption[] = [];
  docStatusOptions = signal<LaasOption[]>([]);
  receivingInstructionEditStatusList: LaasOption[];
  receivingTaskOptions: LaasOptionAdvance[];
  receivingDetailTaskOptions: LaasOptionAdvance[];
  employeeListOptions: LaasOption[] = [];
  transportPriorityOptions = signal<LaasOption[]>([]);
  lockTypeOptions: LaasOption[] = [];
  lockReasonOptions: LaasOption[] = [];
  displayModeOptions: LaasOption[] = [];
  consigneeKeyOptions: LaasOption[] = [];

  taskOptionsByStatus: Map<string, string[]> = new Map();
  detailTaskOptionsByStatus: Map<string, string[]> = new Map();
  currentReceivingTaskOptions: LaasOptionAdvance[] = [];
  currentReceivingDetailTaskOptions: LaasOptionAdvance[] = [];

  tableValue: ReceivingInstructionResponse[];
  tableColumns: Signal<DateTableColumn[]> = computed(() => [
    { field: '__function', header: 'ReceivingInstruction.MainTable.Function' },
    { field: 'adNo', header: 'ReceivingInstruction.MainTable.AdNo', sort: true, filter: { type: 'text' } },
    { field: 'billOfLading', header: 'ReceivingInstruction.MainTable.BillOfLading', sort: true, filter: { type: 'text' } },
    { field: 'taskCode', header: 'ReceivingInstruction.DetailTable.TaskCode', sort: true, filter: { type: 'text' } },
    { field: 'taskRemark', header: 'ReceivingInstruction.DetailTable.TaskRemark', sort: true, filter: { type: 'text' } },
    { field: 'advanceTaskRemark', header: 'ReceivingInstruction.MainTable.AdvanceTaskRemark', sort: true, filter: { type: 'text' } },
    { field: 'file', header: 'ReceivingInstruction.MainTable.File' },
    { field: 'carbonCopyUsers', header: 'ReceivingInstruction.MainTable.CarbonCopyUsers', sort: true, filter: { type: 'text' } },
    { field: 'docStatus', header: 'ReceivingInstruction.MainTable.DocStatus', sort: true, filter: { type: 'multiselect', multiselectOptions: this.docStatusOptions() } },
    { field: 'vendor', header: 'ReceivingInstruction.MainTable.VendorName', sort: true, filter: { type: 'text' } },
    { field: 'notifyUser', header: 'ReceivingInstruction.MainTable.NotifyUser', sort: true, filter: { type: 'text' } },
    { field: 'notifyDt', header: 'ReceivingInstruction.MainTable.NotifyDt', sort: true, dataType: 'date', filter: { type: 'date' } },
    { field: 'isNotify', header: 'ReceivingInstruction.MainTable.IsNotify', sort: true, filter: { type: 'multiselect', multiselectOptions: this.isNotifyOptions() } },
    { field: 'arrivalCnt', header: 'ReceivingInstruction.MainTable.ArrivalCnt', sort: true, filter: { type: 'text' } },
    { field: 'receivedDt', header: 'ReceivingInstruction.MainTable.ReceivedDt', sort: true, dataType: 'date', filter: { type: 'date' } },
    { field: 'facility', header: 'ReceivingInstruction.MainTable.Facility', sort: true, filter: { type: 'multiselect', multiselectOptions: this.facilityOptions() } },
    { field: 'createDt', header: 'ReceivingInstruction.MainTable.CreateDt', sort: true, dataType: 'date', filter: { type: 'date' } },
    { field: 'priority', header: 'ReceivingInstruction.MainTable.Priority', sort: true, filter: { type: 'multiselect', multiselectOptions: this.transportPriorityOptions() } },
    { field: 'importDeclarationNo', header: 'ReceivingInstruction.MainTable.ImportDeclarationNo', sort: true, filter: { type: 'text' } },
  ]);
  detailTableValue: ReceivingInstructionDetailResponse[];
  detailTableColumns: DateTableColumn[] = [
    { field: 'sku', header: 'ReceivingInstruction.DetailTable.Sku', sort: true, filter: { type: 'text' } },
    { field: 'expectedQty', header: 'ReceivingInstruction.DetailTable.ExpectedQty', sort: true, filter: { type: 'numeric' } },
    { field: 'invoiceNo', header: 'ReceivingInstruction.DetailTable.InvoiceNo', sort: true, filter: { type: 'text' } },
    { field: 'taskCode', header: 'ReceivingInstruction.DetailTable.TaskCode', sort: true, filter: { type: 'text' } },
    { field: 'taskRemark', header: 'ReceivingInstruction.DetailTable.TaskRemark', sort: true, filter: { type: 'text' } },
  ];
  selectedTableColumns: DateTableColumn[];
  selectedRow: ReceivingInstructionResponse | null;
  selectedDetailRow: ReceivingInstructionDetailResponse | null;
  selectedRowsWithCheckBox: ReceivingInstructionResponse[];
  detailSelectedRowsWithCheckBox: any[];
  previousDetailSelectedRow: ReceivingInstructionDetailResponse | null;
  cloneDetailTableValue: ReceivingInstructionDetailResponse[];
  allDetailDataValue: ReceivingInstructionDetailResponse[];
  previousSelectedRow: ReceivingInstructionResponse | null;
  cloneTableValue: ReceivingInstructionResponse[];
  isNotifyOptions = signal<LaasOption[]>([]);
  isShowFileDialog: boolean = false;
  fileDocIdOfCurrentReceivingInstruction: string[] = [];

  advanceTaskCode: Map<string, string[]> = new Map();
  receivingTaskCodeGroupLogic: Map<string, string[]> = new Map();
  advanceTaskCodePipe: any={};

  detailGroupBySkuData: ReceivingInstructionDetailGroupBySku[] = [];
  cloneDetailGroupBySkuData: ReceivingInstructionDetailGroupBySku[] = [];


  readonly viewPermissionCode = PermissionConstants.ViewReceivingInstruction;
  readonly editPermissionCode = PermissionConstants.EditReceivingInstruction;

  // PrimeNG ConfirmDialog 關閉動畫預設為 150ms，此處加 50ms buffer 確保 maskVisible 已重置
  private readonly CONFIRM_DIALOG_ANIMATION_MS = 200;
  // 第一個 confirm 的關閉動畫是否已結束
  private confirmDialogAnimationDone = false;
  // 動畫尚未結束時，暫存第二個 confirm 的開啟動作，等動畫結束後再執行
  private pendingConfirmAction: (() => void) | null = null;

  readonly headerPreferenceKey: string = UserPreferenceConstants.ReceivingInstructionResponse;
  readonly detailPreferenceKey: string = UserPreferenceConstants.ReceivingInstructionDetailResponse;

  readonly dayRange: number = 7;
  readonly unEditableStatusCodes: string[] = ['9','F','5'];
  protected readonly OrderQueryScopeEnum = OrderQueryScopeEnum;

  @ViewChild('receivingDetailTable') detailDataTable!: Table;
  @ViewChild('receivingHeaderTable') headerDataTable!: Table;
  @ViewChild('receivedDt') receivedDt!: CalendarComponent;
  @ViewChild('createDt') createDt!: CalendarComponent;
  @ViewChild('fileDialog') fileDialog!: FileUploadDialogComponent;
  @ViewChild('advanceTaskMaintenance') advanceTaskMaintenance!:AdvanceTaskMaintenanceComponent;
  @ViewChild('instructionBatchUpdate') instructionBatchUpdate!:ReceivingInstructionBatchUpdateComponent;

  constructor(injector: Injector, private formBuilder: FormBuilder, private dropdownOptionsService: DropdownOptionsService,
    private facilityService: FacilityService, private commonDataService: CommonDataService, private receivingInstructionService: ReceivingInstructionService,
    private advisingServiceService: AdvisingServiceService,
    private route: ActivatedRoute,private tasklogicService:TaskLogicServiceService,private addressMaintainanceService: AddressMaintainanceService,) {
    super(injector);

    this.isSearchFormOpen = true;
    this.isHeaderTableOpen = true;
    this.isDetailTableOpen = false;
    this.isHeaderLoading = false;
    this.isDetailLoading = false;
    this.headerChecked = false;
    this.detailChecked = false;
    this.firstSearch = false;
    this.canEditTable = true;
    this.editMode = false;
    this.editStatus = '100';
    this.canEditHeaderTaskRemark = false;
    this.canEditDetailTaskRemark = false;
    this.isShowBatchUpdate = false;
    this.visibleTaskAdvance = false;

    this.searchForm = this.formBuilder.group({
      receivingRequestHeader: null,
      receivingRequestDetail: null,
      facility: null,
      hawbNo: null,
      invoiceNo: null,
      receivedDtStart: null,
      receivedDtEnd: null,
      createDtStart: startOfDay(addDays(new Date(), this.dayRange * -1)),
      createDtEnd: endOfDay(new Date()),
      vendorNumber: null,
      importDeclarationNo: null,
      adNo: null,
      sku: null,
      docStatus: null,
      orderQueryScope: this.OrderQueryScopeEnum.all,
      isNotify: null,
    });
    this.defaultCreateDt = [startOfDay(addDays(new Date(), this.dayRange * -1)), endOfDay(new Date())];

    this.first = 0;
    this.pageInfo = {
      pageIndex: 0,
      totalPages: 0,
      totalRecords: 0,
      pageSize: 5
    }
    this.detailPageInfo = {
      pageIndex: 0,
      totalPages: 0,
      totalRecords: 0,
      pageSize: 5
    }

    this.vendorNumberOptions = [];
    this.receivingInstructionEditStatusList = [];
    this.receivingTaskOptions = [];
    this.receivingDetailTaskOptions = [];
    this.consigneeKeyOptions = [];

    this.tableValue = [];
    this.detailTableValue = [];
    this.selectedTableColumns = this.tableColumns();
    this.selectedRow = null;
    this.selectedRowsWithCheckBox = [];
    this.detailSelectedRowsWithCheckBox = [];
    this.selectedDetailRow = null;
    this.previousDetailSelectedRow = null;
    this.cloneDetailTableValue = [];
    this.allDetailDataValue = [];
    this.previousSelectedRow = null;
    this.cloneTableValue = [];
    this.detailSelectedDisplayMode = 'Line';
    this.displayDetailModeBySku = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.displayModeOptions = [{ label: this.translateService.instant('ReceivingInstruction.DetailTable.DisplayMode.Line'), value: 'Line' },{ label: this.translateService.instant('ReceivingInstruction.DetailTable.DisplayMode.Sku'), value: 'Sku' }];

    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.viewPermissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.route.queryParams.subscribe((params: Params) => {
      params = Object.values(params);
      if (params.length != 0) {
        const adNos = params[0].split(";");
        this.searchForm.controls["adNo"].setValue(adNos);
        this.searchBtnClick();
      }
    });

    this.canEditTable = this.permissionCodes.includes(this.editPermissionCode);

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (result) => {
        this.facilityOptions.set(
          [...result].map<LaasOption>((x: FacilityOptions) => {
            return {
              label: x.optionDesc,
              value: x.optionCode,
            };
          })
        )
      }
    })

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'WhDetailStatus').subscribe({
      next: result => {
        const tmpOpts = [...result].map<LaasOption>((x: CodeConverterOptions) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.docStatusOptions.set(tmpOpts);
      }
    });

    this.facilityService.getAllFacilityOptions('RECEIVING_INSTRUCTION_EDIT_STATUS').subscribe({
      next: result => {
        this.receivingInstructionEditStatusList = [...result].map<LaasOption>((x: FacilityOptions) => {
          return {
            label: `${x.optionCode} - ${x.optionDesc}`,
            value: x.optionCode
          };
        });
      }
    })

    this.receivingInstructionService.getReceivingTaskList("header", this.laasSetting.language).subscribe({
      next: result => {
        this.receivingTaskOptions = [...result].map<LaasOptionAdvance>((x: TaskListOptions) => {
          return {
            label: `${x.taskCode} - ${x.taskMean}`,
            value: x.taskCode,
            isDisabled: false
          };
        });
      },
      complete: async () => {
        await this.getReceivingInstructionTaskLogic("header", this.taskOptionsByStatus);
      }
    })

    this.receivingInstructionService.getReceivingTaskList("detail", this.laasSetting.language).subscribe({
      next: result => {
        this.receivingDetailTaskOptions = [...result].map<LaasOptionAdvance>((x: TaskListOptions) => {
          return {
            label: `${x.taskCode} - ${x.taskMean}`,
            value: x.taskCode,
            isDisabled: false
          };
        });
      },
      complete: async () => {
        await this.getReceivingInstructionTaskLogic("detail", this.detailTaskOptionsByStatus);
      }
    })

    this.receivingInstructionService.getEmployeeList().subscribe({
      next: result => {
        this.employeeListOptions = [...result].map<LaasOption>((x: EmployeeListOptions) => {
          return {
            label: `${x.employeeNo} - ${x.employeeName}`,
            value: x.email
          };
        });
      }
    })

    this.facilityService.getAllVendorOptions().subscribe({
      next: (options) => {
        for (let option of options) {
          this.vendorNumberOptions.push({
            label: `${option.optionCode} - ${option.optionDesc}`,
            value: option.optionCode
          });

          this.isNotifyOptions.set([
            { label: 'Y', value: 1 },
            { label: 'N', value: 0 }]
          );
        }
        this.advanceTaskCodePipe.vendorNumberOptions = [];
        this.advanceTaskCodePipe.vendorNumberOptions.push(...this.vendorNumberOptions);
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'TransportPriority').subscribe({
      next: result => {
        this.transportPriorityOptions.set( [...result].map<LaasOption>((x: CodeConverterOptions) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        }));
      }
    });

    this.tasklogicService.getAdvanceTaskList().subscribe({
      next: result => {
        Object.entries(result).forEach(([key, value]: any) => {
              if (!this.advanceTaskCode.has(key)) {
                this.advanceTaskCode.set(key, value);
              }
        });
      }
    });

    this.tasklogicService.getTaskCodeGroupLogic().subscribe({
      next: result => {
        Object.entries(result).forEach(([key, value]: any) => {
          if (!this.receivingTaskCodeGroupLogic.has(key)) {
            this.receivingTaskCodeGroupLogic.set(key, value);
          }
        });
      }
    });

    //LockType
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'TaskAdvanceDropdownList', 'LockType').subscribe({
      next: result => {
        this.lockTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.advanceTaskCodePipe.lockType = [];
        this.advanceTaskCodePipe.lockType.push(...this.lockTypeOptions);
      }
    });

    //LockReason
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'TaskAdvanceDropdownList', 'LockReason').subscribe({
      next: result => {
        this.lockReasonOptions  = [...result].map((x: any) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey,
          };
        });
        this.advanceTaskCodePipe.lockReason = [];
        this.advanceTaskCodePipe.lockReason.push(...this.lockReasonOptions);
      }
    });

      this.addressMaintainanceService.getCustomerOptions().subscribe({
          next: (result) => {
              this.consigneeKeyOptions = [...result].map((x: any) => {
                  return {
                      label: `${x.customerCode} - ${x.customerName}`,
                      value: x.customerCode,
                  };
              });
            this.advanceTaskCodePipe.consigneeKeyOptions = [];
            this.advanceTaskCodePipe.consigneeKeyOptions.push(...this.consigneeKeyOptions);
          },
      });

  }

  async getReceivingInstructionTaskLogic(adTaskType: string, taskOptionByStatusMap: Map<string, string[]>): Promise<void> {
    const result = await this.receivingInstructionService.getReceivingInstructionTaskLogic(adTaskType);
    let taskCodeByStatus: string[] = [];
    taskOptionByStatusMap.clear();
    Object.entries(result).forEach(value => {
      if (!taskOptionByStatusMap.has(value[0])) {
        taskOptionByStatusMap.set(value[0], []);
      }
      for (const taskCode of value[1]) {
        taskCodeByStatus.push(taskCode);
        taskOptionByStatusMap.get(value[0])?.push(taskCode);
      }
    });

    const taskOptions = adTaskType === 'header' ? this.receivingTaskOptions : this.receivingDetailTaskOptions;
    for (const taskOption of taskOptions) {
      if (!taskCodeByStatus.includes(taskOption.value.toString())) {
        for (const [key, value] of taskOptionByStatusMap) {
          value.push(taskOption.value.toString());
        }

        for (const status of this.docStatusOptions()) {
          const statusCode = status.value.toString();
          if (!taskOptionByStatusMap.has(statusCode)) {
            taskOptionByStatusMap.set(statusCode, []);
          }
          taskOptionByStatusMap.get(statusCode)?.push(taskOption.value.toString());
        }
      }
    }
  }

  chipsAdd(event: any, fromControlName: string): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  searchBtnClick() {
    this.resetPageInfo();
    this.headerDataTable.first = 0;
    this.doSearch()
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'receivedDt':
        this.searchForm.controls.receivedDtStart.setValue(date.startDate);
        this.searchForm.controls.receivedDtEnd.setValue(date.endDate);
        break;
      case 'createDt':
        this.searchForm.controls.createDtStart.setValue(date.startDate);
        this.searchForm.controls.createDtEnd.setValue(date.endDate);
        break;
    }
  }

  doSearch() {
    this.isSearchFormOpen = false;
    this.firstSearch = true;
    this.editMode = false;
    this.headerDataTable.cancelRowEdit(this.selectedRow);
    let searchRequest = new ReceivingInstructionRequest();
    searchRequest = copyFormControl(this.searchForm, searchRequest);
    searchRequest.pageIndex = this.pageInfo.pageIndex;
    searchRequest.pageSize = this.pageInfo.pageSize;
    searchRequest.sortInfo = this.sortInfo;
    searchRequest.dataScopes = getDataScopeByPermission(this.userProfile, PermissionConstants.ViewReceivingInstruction);
    searchRequest.pcsrEmail = this.userService.userInfo.email;

    this.isHeaderLoading = true;
    this.isDetailTableOpen = true;
    this.isDetailLoading = true;
    this.receivingInstructionService.searchReceivingInstruction(searchRequest).subscribe({
      next: (result) => {

        this.clearTableFilter(this.headerDataTable);
        this.tableValue = result.content;

        this.tableValue = result.content.map((x: any) => {
          x.vendor = (x.vendorNumber == null ? '' : x.vendorNumber) + '-' + (x.vendorName == null ? '' : x.vendorName);
          return x;
        });

        this.convertTableValue();
        this.cloneTableValue = deepCopy(this.tableValue)!;

        //更改總數量資料
        this.pageInfo.totalRecords = result.totalElements;

        this.detailTableValue = [];
        this.detailPageInfo.totalRecords = 0;
        this.selectedRow = this.tableValue[0];
        this.previousSelectedRow = this.tableValue[0];

        if (this.selectedRow && this.selectedRow.adNo) {
          this.searchDetail(this.selectedRow.adNo);
        } else {
          this.detailTableValue = [];
          this.isDetailLoading = false;
        }

        this.taskCodeOptionCahange('header');
        this.isHeaderLoading = false;
        this.selectedRowsWithCheckBox = [];
        this.detailSelectedRowsWithCheckBox = [];
        this.headerChecked = false;
        this.detailChecked = false;
      }
    });
  }

  resetBtnClick() {
    // this.receivedDt.ngOnInit();
    this.createDt.ngOnInit();
    this.searchForm.reset({
      createDtStart: startOfDay(addDays(new Date(), this.dayRange * -1)),
      createDtEnd: endOfDay(new Date()),
      orderQueryScope: this.OrderQueryScopeEnum.all
    });
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.doSearch();
  }

  tableSort(event: any): void {
    this.resetPageInfo();
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.doSearch();
  }

  detailTablePageChange(event: any) {
    if (this.displayDetailModeByLine){
      this.detailPageInfo.pageSize = event.rows;
      this.detailPageInfo.totalPages = Math.ceil(this.allDetailDataValue.length / this.detailPageInfo.pageSize);
      this.detailPageInfo.pageIndex = event.first / this.detailPageInfo.pageSize;
      if (this.detailPageInfo.pageIndex >= this.detailPageInfo.totalPages) {
        this.detailPageInfo.pageIndex = this.detailPageInfo.totalPages - 1;
      }
      this.detailTableValue = this.updateTableData(this.allDetailDataValue,this.detailPageInfo);
    }else {
      this.detailPageInfo.pageSize = event.rows;
      this.detailPageInfo.totalPages = Math.ceil(this.cloneDetailGroupBySkuData.length / this.detailPageInfo.pageSize);
      this.detailPageInfo.pageIndex = event.first / this.detailPageInfo.pageSize;
      if (this.detailPageInfo.pageIndex >= this.detailPageInfo.totalPages) {
        this.detailPageInfo.pageIndex = this.detailPageInfo.totalPages - 1;
      }
      this.detailGroupBySkuData = this.updateTableData(this.cloneDetailGroupBySkuData,this.detailPageInfo);
    }
  }

  detailTableSort(event: any): void {
    this.detailSortInfo = [{ property: event.field, direction: event.order }];
    this.detailDataTable.cancelRowEdit(this.selectedDetailRow);
    this.detailDataTable.cancelRowEdit(this.previousDetailSelectedRow);
    if (this.selectedRow && this.selectedRow.adNo) {
      this.detailTableValue = this.sortData(this.detailTableValue,event);
    }
  }

  onRowSelect(event: any) {
    if (event.data.adNo !== this.allDetailDataValue[0].adNo) {
      this.resetDetailPageInfo();
      this.detailDataTable.first = 0;
      this.searchDetail(event.data.adNo);
    }
  }

  searchDetail(adNo: string) {
    this.detailDataTable.cancelRowEdit(this.previousDetailSelectedRow);
    let searchRequest = new ReceivingInstructionDetailRequest();
    searchRequest.adNo = adNo;
    searchRequest.pageIndex = this.detailPageInfo.pageIndex;
    searchRequest.pageSize = this.detailPageInfo.pageSize;
    searchRequest.sortInfo = this.detailSortInfo;
    this.displayDetailModeBySku=false;
    this.displayDetailModeByLine=true;
    this.detailSelectedDisplayMode ='Line';

    this.receivingInstructionService.searchReceivingInstructionDetail(searchRequest).subscribe({
      next: (result) => {
        this.clearTableFilter(this.detailDataTable);
        // function splitTaskCodeToList
        this.allDetailDataValue = result;
        this.cloneDetailTableValue = deepCopy(this.allDetailDataValue)!;

        //更改總數量資料
        this.detailPageInfo.totalRecords = result.length;
        this.detailPageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
        this.selectedDetailRow = this.detailTableValue[0];
        this.previousDetailSelectedRow = this.detailTableValue[0];
        this.groupBySku();
        this.detailTableValue = this.updateTableData(this.allDetailDataValue,this.detailPageInfo);
        this.checkDetailDisplayMode();
        this.isDetailLoading = false;
        this.canEditDetailTaskRemark = false;
        this.taskCodeOptionCahange('detail');
        this.isDetailTableOpen = true;
      }
    });
  }

  async searchAllDetail(adNo: string): Promise<ReceivingInstructionDetailResponse[] | undefined> {
    return await this.receivingInstructionService.searchReceivingInstructionAllDetail(adNo);
  }

  resetPageInfo() {
    this.pageInfo = {
      pageSize: this.pageInfo.pageSize,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.first = 0;
  }

  resetDetailPageInfo() {
    this.detailPageInfo = {
      pageSize: this.detailPageInfo.pageSize,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
  }

  selectAllOrUnSelectAll(event: any) {
    if (this.headerChecked) {
      this.selectedRowsWithCheckBox = this.tableValue;
    } else {
      this.selectedRowsWithCheckBox = [];
    }
  }

  detailSelectAllOrUnSelectAll(event: any) {
    if (this.detailChecked) {
      if (this.displayDetailModeBySku) {
        this.detailSelectedRowsWithCheckBox = this.detailGroupBySkuData;
      } else {
        this.detailSelectedRowsWithCheckBox = this.detailTableValue;
      }
    } else {
      this.detailSelectedRowsWithCheckBox = [];
    }
  }

  private clearTableFilter(table: Table) {
    table.clearFilterValues();
    table.filteredValue = null;
    table.saveState();
  }

  async switchEditMode() {
    if (this.editMode) {
      if (this.detailNotSaveConfirm() || this.headerNotSaveConfirm()) {
        await this.getReceivingInstructionTaskLogic('header', this.taskOptionsByStatus);
        await this.getReceivingInstructionTaskLogic("detail", this.detailTaskOptionsByStatus);
        this.confirmationService.confirm({
          message: this.translateService.instant('ReceivingInstruction.Confirm.ChangeSaveOrNot'),
          header: this.translateService.instant('ReceivingInstruction.Confirm.Header'),
          icon: 'pi pi-info-circle',
          accept: () => {
            this.confirmDialogAnimationDone = false;
            this.pendingConfirmAction = null;
            setTimeout(() => {
              this.confirmDialogAnimationDone = true;
              if (this.pendingConfirmAction) {
                const action = this.pendingConfirmAction;
                this.pendingConfirmAction = null;
                action();
              }
            }, this.CONFIRM_DIALOG_ANIMATION_MS);
            this.doHeaderSaveChange();
            this.resetTableLoad();
          },
          reject: (type: any) => {
            switch (type) {
              case ConfirmEventType.REJECT:
                this.resetTableLoad();
                break;
              case ConfirmEventType.CANCEL:
                this.resetTableLoad();
                break;
            }
          }
        });
      } else {
        this.resetTableLoad();
      }
    } else if (this.selectedRow) {
      if (!this.unEditableStatusCodes.some(status => status == this.selectedRow?.docStatus)){
        this.headerDoSwitchRow();
        this.detailDoSwitchRow();
      }
      this.editMode = true;
    }

  }

  detailOnRowClick(dataRow: ReceivingInstructionDetailResponse) {
    this.selectedDetailRow = dataRow;
    if (this.editMode && !this.unEditableStatusCodes.some(status => status == this.selectedRow?.docStatus)) {
      this.detailDoSwitchRow()
    }
  }

  async saveBtnClick() {
    if (this.editMode) {
      await this.getReceivingInstructionTaskLogic('header', this.taskOptionsByStatus);
      await this.getReceivingInstructionTaskLogic("detail", this.detailTaskOptionsByStatus);
      this.isHeaderLoading = true;
      this.confirmationService.confirm({
        message: this.translateService.instant('ReceivingInstruction.Confirm.SaveOrNot'),
        header: this.translateService.instant('ReceivingInstruction.Confirm.Header'),
        icon: 'pi pi-info-circle',
        accept: () => {
            this.confirmDialogAnimationDone = false;
            this.pendingConfirmAction = null;
            setTimeout(() => {
              this.confirmDialogAnimationDone = true;
              if (this.pendingConfirmAction) {
                const action = this.pendingConfirmAction;
                this.pendingConfirmAction = null;
                action();
              }
            }, this.CONFIRM_DIALOG_ANIMATION_MS);
            this.doHeaderSaveChange();
          },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.resetTableLoad();
              break;
            case ConfirmEventType.CANCEL:
              this.resetTableLoad();
              break;
          }
        }
      })
    }
  }

  detailDoSwitchRow() {
    this.detailDataTable.cancelRowEdit(this.previousDetailSelectedRow);
    this.detailDataTable.initRowEdit(this.selectedDetailRow);
    this.taskCodeOptionCahange('detail');
    if (this.editMode && this.selectedDetailRow) {
      if (this.selectedDetailRow.taskCode) {
        for (const taskCode of this.selectedDetailRow.taskCode) {
          if (this.currentReceivingDetailTaskOptions.findIndex(option => option.value === taskCode) < 0) {
            this.selectedDetailRow.taskCode.splice(this.selectedDetailRow.taskCode.indexOf(taskCode), 1);
          }
        }
      }
    }
    this.previousDetailSelectedRow = deepCopy(this.selectedDetailRow);
  }

  async doDetailSaveChange(forceSyncList: string[]): Promise<UpdateAdvisingDetailTaskRequest[]> {
    if (this.selectedRow) {
      this.isDetailLoading = true;
      let updateDetailDataRecivingInsList: UpdateAdvisingDetailTaskRequest[] = [];
      for (const rowVal of this.allDetailDataValue) {
        const cloneRowVal = this.cloneDetailTableValue.find(x => rowVal.adNo === x.adNo && rowVal.externLineNo === x.externLineNo);
        if (!cloneRowVal) {
          continue;
        }

        if (rowVal.adNo === cloneRowVal.adNo && rowVal.externLineNo === cloneRowVal.externLineNo && JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
          if ((isNullOrEmpty(rowVal.taskCode) || rowVal.taskCode?.length == 0) && !isNullOrEmpty(rowVal.taskRemark)) {
            this.toastService.error(this.translateService.instant('ReceivingInstruction.errorMessage.DetailHaveRemarkNotHaveCode'));
            break;
          }

          const validateDetailTaskCode = await this.validateDetailTaskCode(true, rowVal);
          if (!validateDetailTaskCode) {
            break;
          }

          if (JSON.stringify(rowVal) != JSON.stringify(cloneRowVal)) {
            let updateDataRecivingIns = new UpdateAdvisingDetailTaskRequest();
            updateDataRecivingIns.adDetailSeqNo = rowVal.seqNo;
            updateDataRecivingIns.createUser = this.userProfile.uuid;
            updateDataRecivingIns.updateUser = this.userProfile.uuid;
            updateDataRecivingIns.taskCode = rowVal.taskCode;
            updateDataRecivingIns.taskRemark = rowVal.taskRemark;
            updateDataRecivingIns.adNo = rowVal.adNo;
            updateDataRecivingIns.externLineNo = rowVal.externLineNo;
            updateDetailDataRecivingInsList.push(updateDataRecivingIns);
          }

          if (this.selectedRow.isNotify == 1) {
            forceSyncList.push(rowVal.adNo);
          }
        }
      }
      return updateDetailDataRecivingInsList;
    }
    return [];
  }

  saveSuccess(): void {
    this.toastService.success(this.translateService.instant('ReceivingInstruction.Toast.SaveSuccess'));
    this.headerDataTable.cancelRowEdit(this.selectedRow);
    this.detailDataTable.cancelRowEdit(this.selectedDetailRow);
    this.editMode = false;
    this.doSearch();
  }

  authCanEditCode(docStatus: string | undefined): boolean {
    for (const val of this.receivingInstructionEditStatusList) {
      if (docStatus == val.value) {
        return true;
      }
    }
    return false;
  }

  async returnWmsBtnClick() {
    await this.getReceivingInstructionTaskLogic('header', this.taskOptionsByStatus);
    await this.getReceivingInstructionTaskLogic("detail", this.detailTaskOptionsByStatus);
    this.confirmationService.confirm({
      message: this.translateService.instant('ReceivingInstruction.Confirm.ReturnWms'),
      header: this.translateService.instant('ReceivingInstruction.Confirm.Header'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.isHeaderLoading = true;
        this.doReturnWms();
      },reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.resetTableLoad();
            break;
          case ConfirmEventType.CANCEL:
            this.resetTableLoad();
            break;
        }
      }
    });
  }

  async showBatchUpdateDialog(val: boolean,openType?:string): Promise<void> {
    if (this.editMode) {
      this.isShowBatchUpdate = val;
      this.instructionBatchUpdate.openType = openType;
      if (openType == 'header'){
        this.instructionBatchUpdate.receivingTaskOptions = await this.getTaskOptionsListByDocStatus(this.taskOptionsByStatus, 'ALL', this.receivingTaskOptions);
      }else {
        this.instructionBatchUpdate.receivingTaskOptions = await this.getTaskOptionsListByDocStatus(this.detailTaskOptionsByStatus, 'ALL', this.receivingDetailTaskOptions);
      }
    }
  }

  async doReturnWms() {
    let receivingDetailReturnRequest = new ReceivingInstructionDetailReturnRequest();

    for (const checkBoxValue of this.selectedRowsWithCheckBox) {
      if (checkBoxValue.adNo) {
        receivingDetailReturnRequest.adNoList?.push(checkBoxValue.adNo);
      }
    }

    if (receivingDetailReturnRequest.adNoList) {
      const validateHeaderTaskCode = await this.validateHeaderTaskCode(false, receivingDetailReturnRequest.adNoList);
      if (!validateHeaderTaskCode) {
        return;
      }

      for (const adNo of receivingDetailReturnRequest.adNoList) {
        const detailList = await this.searchAllDetail(adNo);
        if (detailList) {
          for (const detail of detailList) {
            if (!await this.validateDetailTaskCode(false, detail)) {
              return;
            }
          }
        }
      }

      receivingDetailReturnRequest.language = this.laasSetting.language;
      receivingDetailReturnRequest.uuid = this.userProfile.uuid;

      this.receivingInstructionService.returnReceivingInstructionTask(receivingDetailReturnRequest).subscribe({
        next: result => {
          this.isHeaderLoading = false;
          this.doSearch();
          this.toastService.success(this.translateService.instant('ReceivingInstruction.DetailTable.ReturnWmsSuccess'));
        },error:error =>{
          this.selectedRowsWithCheckBox = [];
          this.detailSelectedRowsWithCheckBox = [];
          this.headerChecked = false;
          this.detailChecked = false;
          this.isHeaderLoading = false;
          this.toastErrorMessage(error.error);
          this.toastService.error(this.translateService.instant('ReceivingInstruction.DetailTable.ReturnWmsFail'));
          return;
        }
      });
    }
  }

  async validateHeaderTaskCode(isUpdateData: boolean, adNoList: any): Promise<boolean> {
    let msg;
    try {
      var advisingHeaderInfoList = await this.advisingServiceService.queryAdHeaderInfo(adNoList);
    } catch (error) {
      console.log(error);
      var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.AdNoNotFound').toPromise();
      msg = `${laaSFormatString(instantMsg, [adNoList])}\n`;
    }

    if (!isNullOrEmpty(advisingHeaderInfoList)){
      for (const adHeader of advisingHeaderInfoList) {
        const rowVal = this.tableValue.find((x: ReceivingInstructionResponse) => adHeader.adNo === x.adNo);
        if (rowVal) {
          if (isUpdateData) {
            if ((isNullOrEmpty(rowVal.taskCode) || rowVal.taskCode?.length == 0) && !isNullOrEmpty(rowVal.taskRemark)) {
              msg = this.translateService.instant('ReceivingInstruction.errorMessage.HeaderHaveRemarkNotHaveCode');
              break;
            }
          }
          if (!adHeader.docStatus) {
            var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.WmsDocStatusIsNull').toPromise();
            msg = `${laaSFormatString(instantMsg, [adHeader.adNo])}\n`;
            break;
          }

          const taskOptionsListByWmsAdDocStatus = await this.getTaskOptionsListByDocStatus(this.taskOptionsByStatus, adHeader.docStatus, this.receivingTaskOptions);
          if (rowVal.taskCode) {
            for (const taskCode of rowVal.taskCode) {
              if (taskOptionsListByWmsAdDocStatus.findIndex(option => option.value === taskCode) < 0) {
                const docStatusBeforeReceivingByLaas = rowVal.docStatus === '0' || rowVal.docStatus === '1';
                const docStatusBeforeReceivingByWms = adHeader.docStatus === '0' || adHeader.docStatus === '1';
                const docStatusBeforeReceiving = docStatusBeforeReceivingByLaas && docStatusBeforeReceivingByWms;
                if (!docStatusBeforeReceiving && adHeader.docStatus !== rowVal.docStatus) {
                  var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.DocStatusIsDiff').toPromise();
                  msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
                  break;
                }
                if (rowVal.docStatus) {
                  this.currentReceivingTaskOptions = await this.getTaskOptionsListByDocStatus(this.taskOptionsByStatus, rowVal.docStatus, this.receivingTaskOptions);
                }
                if (isUpdateData) {
                  rowVal.taskCode.splice(rowVal.taskCode.indexOf(taskCode), 1);
                }
                var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.DocStatusCannotUpdateTaskCode').toPromise();
                var docStatusOption = this.docStatusOptions().find(option => option.value === adHeader.docStatus)?.label ?? adHeader.docStatus;
                msg = `${laaSFormatString(instantMsg, [rowVal.adNo, docStatusOption, taskCode])}\n`;
                break;
              }
            }
          }

          //note 鎖配貨收料指示 header 檢查
          if (this.checkLockCodeIsDuplication(rowVal, 'header')) {
            var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.HeaderDuplication').toPromise();
            msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
            break;
          }

          //note 鎖配貨收料指示 header&detail 雙向檢查
          if (this.checkLockCodeIsValid(rowVal, 'header')) {
            var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.InValid').toPromise();
            msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
            break;
          }

          //note 鎖配貨收料指示 header 卡控，先註解，User可能需求變更又要增加卡控的特殊邏輯
          if (!this.checkTaskCodeHeaderMaintenance(rowVal)) {
            var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.HeaderRemarkNotMaintenance').toPromise();
            msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
            break;
          }

          //note 進階收料指示 header 卡控
          if (!this.checkAdvanceTaskHeaderMaintenance(rowVal)) {
            var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.HeaderAdvanceRemarkNotMaintenance').toPromise();
            msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
            break;
          }
        }
      }
    }

    if (msg) {
      this.toastService.error(msg);
      this.isHeaderLoading = false;
      if (isUpdateData) {
        this.editMode = true;
        return false;
      }
      return false;
    }
    return true;
  }

  async validateDetailTaskCode(isUpdateData: boolean, rowVal: ReceivingInstructionDetailResponse): Promise<boolean> {
    if (rowVal.taskCode) {
      let msg;
      let lastAdNo = '';
      var adHeader: any;
      for (const taskCode of rowVal.taskCode) {
        if (lastAdNo !== rowVal.adNo) {
          lastAdNo = rowVal.adNo;
          try{
            var advisingHeaderInfoList = await this.advisingServiceService.queryAdHeaderInfo([rowVal.adNo]);
          }catch (error){
            console.log(error);
            var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.AdNoNotFound').toPromise();
            msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
            break;
          }
          if (advisingHeaderInfoList && (advisingHeaderInfoList.length === 0 || !advisingHeaderInfoList[0].docStatus)) {
            var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.WmsDocStatusIsNull').toPromise();
            msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
            break;
          }
          adHeader = advisingHeaderInfoList[0];
        }

        const taskOptionsListByWmsAdDocStatus = await this.getTaskOptionsListByDocStatus(this.detailTaskOptionsByStatus, adHeader.docStatus, this.receivingDetailTaskOptions);
        if (taskOptionsListByWmsAdDocStatus.findIndex(option => option.value === taskCode) < 0) {
          const docStatusBeforeReceivingByLaas = rowVal.docStatus === '0' || rowVal.docStatus === '1';
          const docStatusBeforeReceivingByWms = adHeader.docStatus === '0' || adHeader.docStatus === '1';
          const docStatusBeforeReceiving = docStatusBeforeReceivingByLaas && docStatusBeforeReceivingByWms;
          if (!docStatusBeforeReceiving && adHeader.docStatus !== rowVal.docStatus) {
            var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.DocStatusIsDiff').toPromise();
            msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
            break;
          }
          if (isUpdateData) {
            if (rowVal.docStatus) {
              this.currentReceivingDetailTaskOptions = await this.getTaskOptionsListByDocStatus(this.detailTaskOptionsByStatus, rowVal.docStatus, this.receivingDetailTaskOptions);
            }
            rowVal.taskCode.splice(rowVal.taskCode.indexOf(taskCode), 1);
          }
          var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.DocStatusCannotUpdateTaskCode').toPromise();
          var docStatusOption = this.docStatusOptions().find(option => option.value === adHeader.docStatus)?.label ?? adHeader.docStatus;
          msg = `${laaSFormatString(instantMsg, [rowVal.adNo, docStatusOption, taskCode])}\n`
          break;
        }

        //note 鎖配貨收料指示 detail 卡控
        if (this.checkLockCodeIsDuplication(rowVal,'detail')){
          var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.DetailDuplication').toPromise();
          msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
          break;
        }

        //note 鎖配貨收料指示 header&detail 雙向檢查
        if (this.checkLockCodeIsValid(rowVal,'detail')){
          var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.InValid').toPromise();
          msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
          break;
        }

        //NOTE 鎖配貨收料指示 detail 卡控
        if (!this.checkAdvanceTaskDetailMaintenance(rowVal)){
          var instantMsg = await this.translateService.get('ReceivingInstruction.errorMessage.DetailRemarkNotMaintenance').toPromise();
          msg = `${laaSFormatString(instantMsg, [rowVal.adNo])}\n`;
          break;
        }
      }
      if (msg) {
        this.toastService.error(msg);
        this.isHeaderLoading = false;
        this.isDetailLoading = false;
        if (isUpdateData) {
          this.editMode = true;
          return false;
        }
        return false;
      }
    }
    return true;
  }

  detailNotSaveConfirm(): boolean {
    if (this.editMode) {
      for (const rowVal of this.detailTableValue) {
        for (const cloneRowVal of this.cloneDetailTableValue) {
          if (rowVal.seqNo == cloneRowVal.seqNo) {
            return this.checkRowDataHasChange(rowVal, cloneRowVal);
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }

  headerNotSaveConfirm(): boolean {
    if (this.editMode) {
      for (const rowVal of this.tableValue) {
        for (const cloneRowVal of this.cloneTableValue) {
          if (rowVal.seqNo == cloneRowVal.seqNo) {
            return this.checkRowDataHasChange(rowVal, cloneRowVal);
          }
        }
      }
      return false;
    } else {
      return false;
    }
  }

  headerOnRowClick(dataRow: ReceivingInstructionResponse) {
    this.selectedRow = dataRow;
    if (this.editMode && this.unEditableStatusCodes.some(status => status == this.selectedRow?.docStatus)) {
      this.toastService.warn(this.translateService.instant('ReceivingInstruction.errorMessage.CantNotEdit'));
    }
    if (this.editMode && !this.unEditableStatusCodes.some(status => status == this.selectedRow?.docStatus)) {
      this.headerDoSwitchRow();
    }
  }

  headerDoSwitchRow() {
    this.headerDataTable.cancelRowEdit(this.previousSelectedRow);
    this.headerDataTable.initRowEdit(this.selectedRow);
    this.taskCodeOptionCahange('header');
    if (this.editMode && this.selectedRow) {
      if (this.selectedRow.taskCode) {
        for (const taskCode of this.selectedRow.taskCode) {
          if (this.currentReceivingTaskOptions.findIndex(option => option.value === taskCode) < 0) {
            this.selectedRow.taskCode.splice(this.selectedRow.taskCode.indexOf(taskCode), 1);
          }
        }
      }
    }
    this.previousSelectedRow = deepCopy(this.selectedRow);
  }

  async doHeaderSaveChange() {

    let adNoList: string[] = [];
    let forceSyncList: string[] = [];

    for (let rowVal of this.tableValue) {
      const cloneRowVal = this.cloneTableValue.find(x => rowVal.seqNo === x.seqNo);
      if (!cloneRowVal) {
        continue;
      }

      if (!this.checkRowDataHasChange(rowVal, cloneRowVal)) {
        continue;
      }

      adNoList.push(rowVal.adNo);
      if (cloneRowVal.isNotify === 1) {
        forceSyncList.push(rowVal.adNo);
      }

    }

    let updateHeaderDataRecivingInsList: UpdateAdvisingHeaderTaskRequest[] = [];
    if (adNoList.length > 0) {
      if (!await this.validateHeaderTaskCode(true, adNoList)) {
        return;
      }

      for (const adNo of adNoList) {
        const rowVal = this.tableValue.find((x: ReceivingInstructionResponse) => adNo === x.adNo);
        if (rowVal) {
          let updateDataRecivingIns = new UpdateAdvisingHeaderTaskRequest();
          updateDataRecivingIns.adNo = rowVal.adNo;
          updateDataRecivingIns.createUser = this.userProfile.uuid;
          updateDataRecivingIns.updateUser = this.userProfile.uuid;
          updateDataRecivingIns.taskCode = rowVal.taskCode;
          updateDataRecivingIns.taskRemark = rowVal.taskRemark;
          updateDataRecivingIns.carbonCopyUsers = rowVal.carbonCopyUsers;
          /*
          *因JavaScript的Map對象屬於特殊格式，JSON格式裡不支援轉換Map物件，所以需要在Call Api之前需使用mapToObject序列化
          *否則HTTP在發請求的時候序列化會把Map物件轉成空物件
          */
          updateDataRecivingIns.advanceTaskRemark = mapToObject(rowVal.advanceTaskRemark);
          updateHeaderDataRecivingInsList.push(updateDataRecivingIns);
        }
      }
    }

    const detailRequestData: UpdateAdvisingDetailTaskRequest[] = await this.doDetailSaveChange(forceSyncList);

    let updateReceivingTaskRequest: UpdateReceivingTaskRequest = new UpdateReceivingTaskRequest();
    updateReceivingTaskRequest.receivingTaskHeader = updateHeaderDataRecivingInsList;
    updateReceivingTaskRequest.receivingTaskDetail = detailRequestData;
    updateReceivingTaskRequest.forceSyncFlag = forceSyncList.length > 0;
    updateReceivingTaskRequest.language = this.laasSetting.language;
    updateReceivingTaskRequest.uuid = this.userProfile.uuid;

    forceSyncList = forceSyncList.distinct();
    if (updateReceivingTaskRequest.forceSyncFlag) {
      let forceReturnWMSMsg = this.translateService.instant('ReceivingInstruction.Confirm.ForceReturnWMSMsg');
      let forceReturnWMSMsgAddAdNoList = `${laaSFormatString(forceReturnWMSMsg, [forceSyncList.join(',')])}\n`;
      this.openConfirmAfterAnimationDone(() => this.confirmationService.confirm({
        message: this.translateService.instant(forceReturnWMSMsgAddAdNoList),
        header: this.translateService.instant('ReceivingInstruction.Confirm.ForceReturnWMSHeader'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.isHeaderLoading = true;
          this.doReceivingTaskSave(updateReceivingTaskRequest, updateReceivingTaskRequest.forceSyncFlag);
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              this.resetTableLoad();
              break;
            case ConfirmEventType.CANCEL:
              this.resetTableLoad();
              break;
          }
        }
      }));
    } else {
      this.doReceivingTaskSave(updateReceivingTaskRequest, updateReceivingTaskRequest.forceSyncFlag);
    }

  }

  async taskCodeOptionCahange(checkTable: string) {
    // 用checkTable判斷Header or detail Table的TaskCode下選單變更，讓維空的的TaskCode下拉式選單Reamark關閉
    switch (checkTable) {
      case 'detail':
        if (this.selectedDetailRow) {
          if (this.selectedRow?.docStatus) {
            this.currentReceivingDetailTaskOptions = await this.getTaskOptionsListByDocStatus(this.detailTaskOptionsByStatus, this.selectedRow?.docStatus, this.receivingDetailTaskOptions);
          } else {
            this.currentReceivingDetailTaskOptions = await this.getTaskOptionsListByDocStatus(this.detailTaskOptionsByStatus, 'ALL', this.receivingDetailTaskOptions);
          }
          if (this.selectedDetailRow?.taskCode?.length! == 0 || isNullOrEmpty(this.selectedDetailRow?.taskCode) || this.currentReceivingDetailTaskOptions.length == 0) {
            this.canEditDetailTaskRemark = false;
            this.selectedDetailRow.taskRemark = null;
          } else {
            this.canEditDetailTaskRemark = true;
          }

          const allTaskCode:string[] = concatHeaderAndDetailTaskArray(this.selectedRow?.taskCode,this.selectedDetailRow?.taskCode);

          this.currentReceivingDetailTaskOptions =await this.checkOptionLockStatus(this.currentReceivingDetailTaskOptions,allTaskCode);
          this.syncDetailLine(this.selectedDetailRow);
        }
        break;
      case 'header':
        if (this.selectedRow) {
          if (this.selectedRow?.docStatus) {
            this.currentReceivingTaskOptions = await this.getTaskOptionsListByDocStatus(this.taskOptionsByStatus, this.selectedRow?.docStatus, this.receivingTaskOptions);
          } else {
            this.currentReceivingTaskOptions = await this.getTaskOptionsListByDocStatus(this.taskOptionsByStatus, 'ALL', this.receivingTaskOptions);
          }
          if (this.selectedRow?.taskCode?.length! == 0 || isNullOrEmpty(this.selectedRow?.taskCode) || this.currentReceivingTaskOptions.length == 0) {
            this.canEditHeaderTaskRemark = false;
            this.selectedRow.taskRemark = null;
          } else {
            this.canEditHeaderTaskRemark = true;
          }

          if (this.editMode && !this.checkAdvanceTask(this.selectedRow)) {
            this.selectedRow.advanceTaskRemark = new Map();
          }

          const taskCodeArray: string[] = this.allDetailDataValue.reduce((acc: string[], item: ReceivingInstructionDetailResponse) => {
            if (item.taskCode) {
              return acc.concat(item.taskCode);
            }
            return acc;
          }, [] as string[]);
          const allTaskCode:string[] = concatHeaderAndDetailTaskArray(this.selectedRow?.taskCode,taskCodeArray);
          this.currentReceivingTaskOptions =await this.checkOptionLockStatus(this.currentReceivingTaskOptions,allTaskCode);

          this.currentReceivingDetailTaskOptions =await this.checkOptionLockStatus(this.currentReceivingDetailTaskOptions,allTaskCode);
        }
    }
  }

  async getTaskOptionsListByDocStatus(taskOptionsByStatusMap: Map<string, string[]>, docStatus: string, taskOptions: LaasOptionAdvance[]): Promise<LaasOptionAdvance[]> {
    const taskCodeList = taskOptionsByStatusMap.has(docStatus) ? taskOptionsByStatusMap.get(docStatus) : undefined;
    if (taskCodeList) {
      return taskOptions.filter((x: any) => taskCodeList?.includes(x.value));
    }
    return taskOptions;
  }

  restTableValueToDefaultValue() {

    this.confirmationService.confirm({
      header: this.translateService.instant('ReceivingInstruction.Confirm.Header'),
      message: this.translateService.instant('ReceivingInstruction.Confirm.Restore'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.tableValue = deepCopy(this.cloneTableValue)!;
        this.detailTableValue = deepCopy(this.cloneDetailTableValue)!;
        this.toastService.success(this.translateService.instant('ReceivingInstruction.Toast.RestoreSuccess'))
      }
    })
  }

  async setHeaderPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.pageInfo.pageSize = event.rows;
  }

  async setDetailPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.detailPageInfo.pageSize = event.rows;
  }

  updateReceivingInstruction(receivingInstruction: any): void {
    // 處理檔案上傳成功的情況
    if (receivingInstruction.uploadSuccess) {
      this.doSearch();
      this.showBatchUpdateDialog(false);
      return;
    }

    let task: string = '';
    let taskValue: any = null;

    if (receivingInstruction.openType == 'header'){
      for (const rowVal of this.selectedRowsWithCheckBox) {
        rowVal.taskCode = receivingInstruction.taskCode;
        rowVal.taskRemark = receivingInstruction.taskRemark;
        if (!isNullOrEmpty(receivingInstruction.advanceTask)) {
          rowVal.advanceTaskRemark = new Map();
          Object.entries(receivingInstruction?.advanceTask).forEach((value => {
            task = Object.values(value)[0] as string;
            taskValue = Object.values(value)[1];
            rowVal.advanceTaskRemark?.set(task, taskValue);
          }));
        }
      }
    }else{
      for (const rowVal of this.detailSelectedRowsWithCheckBox) {
        rowVal.taskCode = receivingInstruction.taskCode;
        rowVal.taskRemark = receivingInstruction.taskRemark;
      }
      this.syncDetailLine(this.detailSelectedRowsWithCheckBox);
    }

    this.taskCodeOptionCahange(receivingInstruction.openType);
    this.showBatchUpdateDialog(false);
  }

  showFiles(event: Event, rowData: ReceivingInstructionResponse) {
    this.headerOnRowClick(rowData);
    this.fileDocIdOfCurrentReceivingInstruction = deepCopy(this.selectedRow?.docIds) ?? [];
    this.fileDialog.changeUploadMode('single');
    this.fileDialog.visibleChange(true);
    this.getReceivingInstructionFile();
  }

  getReceivingInstructionFile(): void {
    this.fileDialog.isFileDialogLoading = true;
    let fileRequest = new ReceivingInstructionFilesRequest();
    fileRequest.userName = this.userProfile.userName;
    fileRequest.docIds = this.fileDocIdOfCurrentReceivingInstruction;

    this.receivingInstructionService.findFilesByDocId(fileRequest).subscribe({
      next: (response: any) => {
        if (response.files) {
          this.fileDialog.fileList = [];
          this.setReceivingInstructionFile(response);
        }
      },
      complete: () => {
        this.fileDialog.isFileDialogLoading = false;
      }
    });
  }

  setReceivingInstructionFile(response: any) {
    if (response.files) {
      for (let responseFile of response.files) {
        let advisingTaskFile = new ReceivingInstructionFileItem();
        advisingTaskFile.docId = responseFile.docId;
        advisingTaskFile.fileName = responseFile.fileName;
        advisingTaskFile.fileExtension = responseFile.fileExtension;
        advisingTaskFile.fileType = responseFile.fileType;
        advisingTaskFile.fileDataUrl = `data:${responseFile.fileType};base64,${responseFile.fileContent}`;
        this.fileDialog.filePermission = responseFile.filePermission;
        this.fileDialog.fileList.push(advisingTaskFile);
      }
    }
  }

  saveFile(req: any): void {
    let updateRequest = this.genReceivingInstructionFileUpdateRequest(req);
    this.receivingInstructionService.updateReceivingInstructionFile(updateRequest).subscribe({
      next: (response) => {
        if (this.fileDialog.singleUploadMode) {
          this.selectedRow!.docIds = response.updateReceivingInstructionList[0].docIds;
          this.toastService.success(this.translateService.instant('Common.Message.SuccessSave'));
          return;
        }

        for (const rowVal of this.selectedRowsWithCheckBox) {
          if (rowVal.adNo) {
            const adNo = rowVal.adNo;
            for (const updateRowData of response.updateReceivingInstructionList) {
              if (updateRowData.adNo === adNo) {
                rowVal.docIds = updateRowData.docIds;
              }
            }
          }
        }
        this.toastService.success(this.translateService.instant('Common.Message.SuccessSave'));
      },
      error: (response) => {
        this.toastService.error(this.translateService.instant('Common.Dialog.Message.File.SaveFailure') + response.status);
      },
      complete: () => {
        this.fileDialog.onCloseDialog();
      }
    })
  }

  genReceivingInstructionFileUpdateRequest(req: any): ReceivingInstructionFileUpdateRequest {
    const request = new ReceivingInstructionFileUpdateRequest();
    request.userName = req.userName;
    request.operationDate = req.operationDate;
    request.newFiles = req.newFiles;
    if (this.fileDialog.singleUploadMode) {
      request.deletedFileDocIds = req.deletedFileDocIds;
      if (this.selectedRow?.adNo) {
        request.adNos.push(this.selectedRow?.adNo);
      }
      return request;
    }

    for (const rowVal of this.selectedRowsWithCheckBox) {
      if (rowVal.adNo) {
        request.adNos.push(rowVal.adNo);
      }
    }
    return request;
  }

  restoreFileData(): void {
    this.fileDialog.newFileBase64s = [];
    this.fileDialog.deletedFileDocIds = [];
    if (this.fileDialog.singleUploadMode) {
      this.fileDocIdOfCurrentReceivingInstruction = deepCopy(this.selectedRow?.docIds) ?? [];
      this.getReceivingInstructionFile();
      return;
    }
    this.fileDialog.fileList = [];
  }

  showFileUploadDialog(): void {
    for (const rowVal of this.selectedRowsWithCheckBox) {
      if (rowVal.docStatus === 'F') {
        this.toastService.error(this.translateService.instant('ReceivingInstruction.errorMessage.DocStatusCannotUploadFile'));
        return;
      }
    }
    this.fileDialog.changeUploadMode('batch');
    this.fileDialog.visibleChange(true);
  }

  convertTableValue() {
    if (this.tableValue != null) {
      for (let i = 0; i < this.tableValue.length; i++) {
          if (this.tableValue[i].taskCode?.length == 1 ) {
            if (isNullOrEmpty(this.tableValue[i].taskCode![0])) {
              this.tableValue[i].taskCode = [];
            }
          }
        this.tableValue[i].taskCode = this.sortTaskCodes(this.tableValue[i].taskCode);

        if (this.tableValue[i].advanceTaskRemark && !isNullOrEmpty(this.tableValue[i].advanceTaskRemark)){
            this.tableValue[i].advanceTaskRemark = new Map(Object.entries(this.tableValue[i].advanceTaskRemark!));
        }
      }

    }
  }

  checkAdvanceTask(rowData: any) {
    return this.editMode && rowData.taskCode?.some((taskCode: any) => Array.from(this.advanceTaskCode.keys()).includes(taskCode));
  }

  async checkOptionLockStatus(optionAdvances: LaasOptionAdvance[], taskCode: any): Promise<LaasOptionAdvance[]> {
    const filterLockGroupMap = new Map<string, string[]>();
    const optionAdvancesCheck = optionAdvances;

    for (const [key, value] of this.receivingTaskCodeGroupLogic) {
      const filteredValue = value.filter(item => taskCode.includes(item));
      if (filteredValue.length > 0) {
        filterLockGroupMap.set(key, value);
      }
    }

    const groupValues: string[] = Array.from(filterLockGroupMap.values()).reduce((acc, curr) => acc.concat(curr), []);
    optionAdvancesCheck.forEach((option: any) => {
      const selectTaskCodeIsAdvanceTask: boolean = !isNullOrEmpty(taskCode) && groupValues.some((lockTask) => taskCode.includes(lockTask));
      if (!isNullOrEmpty(taskCode) && taskCode.length > 0 && selectTaskCodeIsAdvanceTask) {
        const isLock = groupValues.includes(option.value);
        option.isDisabled = isLock && !taskCode.includes(option.value);
      } else {
        option.isDisabled = false;
      }
    });

    return optionAdvancesCheck;
  }

  showTaskAdvanceDialog(val: boolean) {
    if (this.editMode) {
      this.visibleTaskAdvance = val;
    }
  }

  updateAdvanceTask(advanceTask: any) {
    this.showTaskAdvanceDialog(false);
    this.selectedRow!.advanceTaskRemark = new Map();

    Object.entries(advanceTask).forEach((value => {
      const task = Object.values(value)[0] as string;
      const taskValue: any = Object.values(value)[1];

      if (!this.selectedRow?.advanceTaskRemark?.has(task)) {
        this.selectedRow?.advanceTaskRemark?.set(task, taskValue);
      }
    }));
  }

  checkDetailDisplayMode() {
    this.resetDetailPageInfo();
    this.detailSelectedRowsWithCheckBox = [];
    this.detailChecked = false;
    switch (this.detailSelectedDisplayMode) {
      case 'Line':
        this.displayDetailModeBySku = false;
        this.displayDetailModeByLine = true;
        this.detailPageInfo.totalRecords = this.allDetailDataValue.length;
        this.detailPageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
        this.detailTableValue = this.updateTableData(this.allDetailDataValue, this.detailPageInfo);
        this.detailDataTable.dataKey = 'seqNo';
        this.detailOnRowClick(this.detailTableValue[0]);
        break;
      case 'Sku':
        this.groupBySku();
        this.displayDetailModeBySku = true;
        this.displayDetailModeByLine = false;
        this.detailPageInfo.totalRecords = this.cloneDetailGroupBySkuData.length;
        this.detailPageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
        this.detailGroupBySkuData = this.updateTableData(this.cloneDetailGroupBySkuData, this.detailPageInfo);
        this.detailDataTable.dataKey = 'sku';
        break;
      default:
        this.displayDetailModeBySku = false;
        this.displayDetailModeByLine = true;
        break;
    }
    this.detailDataTable.cancelRowEdit(this.selectedDetailRow);
    this.detailDataTable.cancelRowEdit(this.previousDetailSelectedRow);
  }

  groupBySku() {
    const grouped: Record<string, ReceivingInstructionDetailGroupBySku> = {};
    this.allDetailDataValue.forEach(item => {
      if (!isNullOrEmpty(item.sku)) {
        const sku: string = item.sku!;

        if (!grouped[item.sku!]) {
          grouped[sku] = {
            adNo: item.adNo,
            sku: sku,
            taskCode: item.taskCode ? [...item.taskCode] : [],
            taskRemark: item.taskRemark,
            externLineNo: item.externLineNo ? [item.externLineNo] : [],
            expectedQty:item.expectedQty || 0,
          };
        } else {
          if (item.taskCode && item.taskCode.length > 0) {
            grouped[sku].taskCode = [...new Set([...grouped[sku].taskCode, ...item.taskCode])];
          }

          if (item.externLineNo && !grouped[sku].externLineNo.includes(item.externLineNo)) {
            grouped[sku].externLineNo.push(item.externLineNo);
          }
          grouped[sku].expectedQty += item.expectedQty || 0;
        }
      }
    });

    this.detailGroupBySkuData = Object.values(grouped);
    this.cloneDetailGroupBySkuData = deepCopy(this.detailGroupBySkuData)!;
  }

  sortData(tableValue: any, event: any): ReceivingInstructionDetailResponse[] {
    this.detailDataTable.cancelRowEdit(this.selectedDetailRow);
    this.detailDataTable.cancelRowEdit(this.previousDetailSelectedRow);

    return tableValue.sort((x: any, y: any) => {
      let valueA = x[event.field];
      let valueB = y[event.field];

      if (valueA instanceof Date && valueB instanceof Date) {
        valueA = valueA ? new Date(valueA).getTime() : 0;
        valueB = valueB ? new Date(valueB).getTime() : 0;
      }

      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return (event.order || 1) * (valueA - valueB);
      }

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return (event.order || 1) * valueA.localeCompare(valueB);
      }

      return 0;
    });
  }

  updateTableData(tableValue: any, pageInfo: PageInfo): any[] {
    this.detailDataTable.cancelRowEdit(this.selectedDetailRow);
    this.detailDataTable.cancelRowEdit(this.previousDetailSelectedRow);
    const start = pageInfo.pageIndex * pageInfo.pageSize;
    const end = (pageInfo.pageIndex * pageInfo.pageSize) + pageInfo.pageSize;
    return tableValue.slice(start, end);
  }

  syncDetailLine(selectedDetailRow: any) {
    if (this.displayDetailModeBySku) {
      this.syncDetailLineWithSkuMode();
    }else{
      this.syncDetailLineWithLineMode(selectedDetailRow);
    }
  }

  checkAdvanceTaskHeaderMaintenance(rowVal: ReceivingInstructionResponse): boolean {
      if (!rowVal.taskCode?.some((taskCode: any) => Array.from(this.advanceTaskCode.keys()).includes(taskCode))) {
          return true;
      }

      if (!rowVal.advanceTaskRemark || rowVal.advanceTaskRemark.size === 0) {
          return false;
      }

      let isValid = true;
      for (const [advanceTaskCode, advanceTaskvalue] of rowVal.advanceTaskRemark) {
          if (isNullOrEmpty(advanceTaskCode) || isNullOrEmpty(advanceTaskvalue)) {
              isValid = false;
              break;
          }

          for (const [fieldName, fieldValue] of Object.entries(advanceTaskvalue)) {
              if (fieldName == "otherReasonDesc"){
                continue;
              }

              if (isNullOrEmpty(fieldName) || isNullOrEmpty(fieldValue)) {
                  isValid = false;
                  break;
              }
          }

          if (!isValid) {
              return false;
          }
      }

      return true;
  }

  checkTaskCodeHeaderMaintenance(rowVal: ReceivingInstructionResponse): boolean {

    if (rowVal.taskCode?.includes('N03-7')) {
      if (isNullOrEmpty(rowVal.taskRemark)) {
        return false;
      }
    }

    return true;
  }

  checkAdvanceTaskDetailMaintenance(rowVal: ReceivingInstructionDetailResponse): boolean {

    if (rowVal.taskCode?.includes('ND03-7')) {
      if (isNullOrEmpty(rowVal.taskRemark)) {
        return false;
      }
    }

    return true;
  }

  private checkRowDataHasChange(rowVal: any, cloneRowVal: any) {
    const serializeData = (data: any): any => {
      if (Array.isArray(data)) {
        return data.map(item => serializeData(item));
      } else if (typeof data === 'object' && data !== null) {
        const result: any = {};
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            if (key === 'advanceTaskRemark' && data[key] instanceof Map) {
              result[key] = mapToObject(data[key]);
            } else {
              result[key] = serializeData(data[key]);
            }
          }
        }
        return result;
      }
      return data;
    };

    const rowValSerializable = serializeData(rowVal);
    const cloneRowValSerializable = serializeData(cloneRowVal);
    return JSON.stringify(rowValSerializable) !== JSON.stringify(cloneRowValSerializable);
  }

  private syncDetailLineWithSkuMode() {
    for (const groupData of this.detailGroupBySkuData) {
      this.allDetailDataValue.forEach((detailData) => {
        if (this.editMode && groupData.externLineNo.some((no) => detailData.externLineNo == no)) {
          detailData.taskCode = groupData.taskCode?[...groupData.taskCode]:null;
          detailData.taskRemark = groupData.taskRemark;
        }
      });
    }
  }

  private syncDetailLineWithLineMode(selectedDetailRow: any) {
    const specialTaskCodes = ['ND03-6', 'ND03-7'];
    for (const detailRow of this.allDetailDataValue) {
      if (Array.isArray(selectedDetailRow)){
        for (const selectedDetailRowElement of selectedDetailRow) {
          if (selectedDetailRowElement.sku ===detailRow.sku ) {
            const nonSpecialCodes = detailRow.taskCode?.filter(code => !specialTaskCodes.includes(code)) || [];
            const specialCodes = selectedDetailRowElement.taskCode?.filter((code:any) => specialTaskCodes.includes(code)) || [];
            const updatedTaskCodes = [...nonSpecialCodes, ...specialCodes];
            detailRow.taskCode = updatedTaskCodes.length > 0 ? updatedTaskCodes : null;
            detailRow.taskRemark = updatedTaskCodes.length > 0 ? selectedDetailRowElement.taskRemark : detailRow.taskRemark;
          }
        }
      }else {
        if (selectedDetailRow.sku ===detailRow.sku) {
          const nonSpecialCodes = detailRow.taskCode?.filter(code => !specialTaskCodes.includes(code)) || [];
          const specialCodes = selectedDetailRow.taskCode?.filter((code:any) => specialTaskCodes.includes(code)) || [];
          const updatedTaskCodes = [...nonSpecialCodes, ...specialCodes];
          detailRow.taskCode = updatedTaskCodes.length > 0 ? updatedTaskCodes : null;
          detailRow.taskRemark = updatedTaskCodes.length > 0 ? selectedDetailRow.taskRemark : null;
        }
      }
    }
  }

  private checkLockCodeIsValid(rowVal: any, action: string) {
    let headerLockTaskCode= ['N03-5', 'N03-6', 'N03-7'];
    let detailLockTaskCode = ['ND03-6', 'ND03-7'];

    if (action == 'header') {
      if (!isNullOrEmpty(rowVal.taskCode) && rowVal.taskCode.size != 0 && rowVal.taskCode.some((code:any) => headerLockTaskCode.includes(code))){
        const detailTaskCode = this.allDetailDataValue.filter(detail => detail.adNo == rowVal.adNo);
        return detailTaskCode.some((taskCode) => taskCode.taskCode?.some((code) => detailLockTaskCode.includes(code)));
      }
    }

    if (action == 'detail') {
      if (!isNullOrEmpty(rowVal.taskCode) && rowVal.taskCode.size != 0 && rowVal.taskCode.some((code:any) => detailLockTaskCode.includes(code))){
        const headerTaskCode = this.tableValue.filter(header => header.adNo == rowVal.adNo);
        return headerTaskCode.some((taskCode) => taskCode.taskCode?.some((code) => headerLockTaskCode.includes(code)));
      }
    }

    return false;
  }

  private checkLockCodeIsDuplication(rowVal: any, action: string) {
    let headerLockTaskCode= ['N03-5', 'N03-6', 'N03-7'];
    let detailLockTaskCode = ['ND03-6', 'ND03-7'];

    if (action == 'header') {
      if (!isNullOrEmpty(rowVal.taskCode) && rowVal.taskCode.size != 0 && rowVal.taskCode.some((code:any) => headerLockTaskCode.includes(code))){
        const headerDuplication = headerLockTaskCode.filter((code:any) => rowVal.taskCode.includes(code));
        return headerDuplication.length > 1;
      }
    }

    if (action == 'detail') {
      if (!isNullOrEmpty(rowVal.taskCode) && rowVal.taskCode.size != 0 && rowVal.taskCode.some((code:any) => detailLockTaskCode.includes(code))){
        const detailDuplication = detailLockTaskCode.filter((code:any) => rowVal.taskCode.includes(code));
        return detailDuplication.length > 1;
      }
    }

    return false;
  }

  sortTaskCodes(taskCodes: (string | null)[] | undefined): string[] {
    if (!taskCodes) {
      return [];
    }

    return taskCodes
        .filter((code): code is string => code !== null)
        .sort((a, b) => {
          const [aLetter, aNumber] = a.split('-');
          const [bLetter, bNumber] = b.split('-');

          if (aLetter !== bLetter) {
            return aLetter.localeCompare(bLetter);
          }

          return parseInt(aNumber) - parseInt(bNumber);
        });
  }

  doReceivingTaskSave(updateReceivingTaskRequest: UpdateReceivingTaskRequest, forceSyncData: boolean) {
    this.receivingInstructionService.updateReceivingTask(updateReceivingTaskRequest).subscribe({
      next: (result) => {
        this.saveSuccess();
        if (forceSyncData) {
          this.toastService.success(this.translateService.instant('ReceivingInstruction.DetailTable.ReturnWmsSuccess'));
        }
        return;
      }, error: (error) => {
        this.resetTableLoad();
        if (forceSyncData) {
          this.toastService.warn(this.translateService.instant('ReceivingInstruction.DetailTable.ReturnWmsFail'));
        }
        this.toastErrorMessage(error.error);
        this.resetTableLoad();
        return;
      }
    });
  }

  resetTableLoad(){
    this.isHeaderLoading = false;
    this.isDetailLoading = false;
    this.headerChecked = false;
    this.detailChecked = false;
    this.selectedRowsWithCheckBox = [];
    this.detailSelectedRowsWithCheckBox = [];
  }

  /**
   * 確保第一個 ConfirmDialog 的關閉動畫（150ms）結束後才開啟第二個 confirm。
   * 若動畫已結束（flag=true）則立刻執行；否則暫存等 setTimeout 觸發。
   */
  private openConfirmAfterAnimationDone(action: () => void): void {
    if (this.confirmDialogAnimationDone) {
      action();
    } else {
      this.pendingConfirmAction = action;
    }
  }

  // 取得選取的 AD No. 列表
  getSelectedAdNoList(): string[] {
    return this.selectedRowsWithCheckBox
      .filter(row => row.adNo)
      .map(row => row.adNo!);
  }
}


